module.exports = __webpack_public_path__ + "static/media/C2.5bebb530.jpg";